import { fetchAPI } from '@quickbit/backoffice-core-frontend';
import { Pagination, SettlementReport, SettlementReportDetails } from './types';

const convertToDate = <T extends SettlementReport>(report: T): T => ({
  ...report,
  startTime: new Date(report.startTime),
  endTime: new Date(report.endTime),
  payments: report.payments.map((payment) => ({
    ...payment,
    createdAt: new Date(payment.createdAt),
    paidAt: new Date(payment.paidAt),
  })),
});

export const getSettlementReport = async (
  reportId: string
): Promise<SettlementReportDetails> => {
  const report = await fetchAPI<SettlementReportDetails>(
    `v1/settlement-reports/${reportId}`
  );
  const withConvertedDatesReport = convertToDate(report);
  return {
    ...withConvertedDatesReport,
    orders: report.orders.map((order) => ({
      ...order,
      completedAt: order.completedAt ? new Date(order.completedAt) : null,
      createdAt: new Date(order.createdAt),
    })),
    refunds: report.refunds.map((refund) => ({
      ...refund,
      createdAt: new Date(refund.createdAt),
    })),
  };
};

interface SettlementReportOverview {
  reports: SettlementReport[];
  aggregatedData: {
    count: number;
  };
}

interface SettlementReportFilters {
  merchantId: string;
}

export const getSettlementReports = async ({
  pagination,
  filters,
}: {
  pagination?: Pagination;
  filters: SettlementReportFilters;
}) => {
  const response = await fetchAPI<SettlementReportOverview>(
    `v1/settlement-reports:search`,
    { method: 'POST', body: { pagination, filters } }
  );
  return {
    reports: response.reports.map(convertToDate),
    aggregatedData: response.aggregatedData,
  };
};
